import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BusApiService } from 'src/app/services/api/bus-api.service';
import { MessageService } from 'src/app/services/message.service';
import { RefundWalletModalComponent } from '../refund-wallet-modal/refund-wallet-modal.component';
import { RefundWalletAdobeModalComponent } from '../refund-wallet-adobe-modal/refund-wallet-adobe-modal.component';

@Component({
  selector: 'app-choose-compensate-adobe-modal',
  templateUrl: './choose-compensate-adobe-modal.component.html',
  styleUrls: ['./choose-compensate-adobe-modal.component.scss'],
})
export class ChooseCompensateAdobeModalComponent implements OnInit {
  index = 3;

  constructor(
    protected dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ChooseCompensateAdobeModalComponent>,
    private api: BusApiService,
    private message: MessageService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getRefundInfoAdobe();
  }

  changeIndex(i: number) {
    this.index = i;
  }

  infos: any;
  loading = false;

  async change() {
    try {
      this.loading = true;
      const r = await this.api.changeAdobe(this.data.id);
      if (r.status === 0) {
        this.message.open('兑换成功');
        this.dialogRef.close();
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/user/profile/seats']);
          });
      } else {
        this.message.warn('兑换失败');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  refund() {
    this.dialogRef.close();
    this.dialog.open(RefundWalletAdobeModalComponent, {
      width: '570px',
      data: Object.assign({}, this.data, { info: this.info }),
      panelClass: 'app-dialog',
    });
  }

  info: any;
  async getRefundInfoAdobe() {
    try {
      this.loading = true;
      const r = await this.api.getRefundInfoAdobe(this.data.id);
      this.info = r.data;
      if (this.info?.remaining_days < 15) {
        this.index = 4;
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
